export default __webpack_public_path__ + "static/media/slide7.cad05074.jpeg";